import React from "react";
import { Paper, Typography, Button } from "@mui/material";
import PrintPanel from "./PrintPanel";
import { fmtTime } from "./racePdf";

// Course populaire : pas de codex, pas de points ni de pénalité.
// Impression par catégorie + export CSV du classement.
export default function PopulairePanel({ config, eventKey, apiFetch, saveConfig, setError, setStatus }) {
    const exportCsv = async () => {
        setError("");
        if (!(await saveConfig())) return;
        const res = await apiFetch(`/api/timing/live/${encodeURIComponent(eventKey)}`);
        if (!res) return;
        if (!res.ok) {
            setError(`HTTP ${res.status}`);
            return;
        }
        const live = await res.json();
        const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
        const lines = [
            ["Rang", "Dossard", "Nom", "Année", "Club", "Catégorie", "Temps", "Statut"].map(esc).join(";"),
            ...(live.ranking || []).map((r) => [r.rank, r.bib, r.name, r.yearBirth, r.club, r.category, fmtTime(r.elapsedMs), ""].map(esc).join(";")),
            ...(live.notClassified || []).map((n) => ["", n.bib, n.name, n.yearBirth, n.club, n.category, "", n.status].map(esc).join(";")),
        ];
        // BOM pour qu'Excel ouvre correctement les accents.
        const blob = new Blob(["\uFEFF" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${eventKey}-classement.csv`;
        a.click();
        URL.revokeObjectURL(url);
        setStatus("CSV téléchargé");
    };

    return (
        <>
            <PrintPanel config={config} eventKey={eventKey} apiFetch={apiFetch} setError={setError} />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" mb={1}>Export du classement</Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    Fichier CSV (séparateur point-virgule) pour Excel ou la publication sur le site de l'organisateur.
                </Typography>
                <Button variant="outlined" onClick={exportCsv}>Télécharger le CSV</Button>
            </Paper>
        </>
    );
}
